import { createSlice } from "@reduxjs/toolkit";
import { createAppAsyncThunk } from "../../../redux-helpers";
import * as dataActions from "../../data/teams";
const prefix = "app/team-dialog";

type FormData = {
  teamId?: string;
  name: string;
  description: string;
};
type State = {
  formData: FormData | null;
};

const initialState: State = { formData: null };

export const submit = createAppAsyncThunk(
  `${prefix}/submit`,
  async (data: FormData, { dispatch }) => {
    if (data.teamId) {
      await dispatch(
        dataActions.updateTeam({
          teamId: data.teamId,
          name: data.name,
          description: data.description,
        })
      ).unwrap();
    } else {
      await dispatch(
        dataActions.addTeam({ name: data.name, description: data.description })
      ).unwrap();
    }
  }
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {
    newTeam: (_state: State): State => ({
      formData: { name: "", description: "" },
    }),
    editTeam: (
      _state: State,
      action: { payload: { teamId: string; name: string; description: string } }
    ): State => ({
      formData: {
        teamId: action.payload.teamId,
        name: action.payload.name,
        description: action.payload.description,
      },
    }),
    close: (_state) => ({ formData: null }),
  },
  extraReducers: (builder) => {
    builder.addCase(submit.fulfilled, (state) => {
      state.formData = null;
    });
  },
});

export const { newTeam, editTeam, close } = slice.actions;
export default slice.reducer;
